import { For } from '@chakra-ui/react';
import React, { Fragment } from 'react';

import { Display } from '@/modules/shared/presentation';

import { useJobDetailContext } from './JobDetail';

export const CompanyInformation = () => {
	const { job } = useJobDetailContext();

	const details = [
		{
			label: 'Company Name',
			value: job.company.name,
		},
		{
			label: 'Business Description',
			value: job.company.description,
		},
		{
			label: 'Main Office',
			value: job.company.mainOffice,
		},
		{
			label: 'Establishment',
			value: job.company.establishment,
		},
		{
			label: 'CEO',
			value: job.company.ceo,
		},
		{
			label: 'Capital',
			value: job.company.capital,
		},
		{
			label: 'Corporate Website',
			value: job.company.corporateWebsite,
		},
	];

	return (
		<Display.Root>
			<Display.Header
				bg="primary.50"
				color="primary.100"
				textAlign="center"
			>
				Company Information
			</Display.Header>
			<Display.Grid gridTemplateColumns="300px 1fr">
				<For each={details}>
					{detail => (
						<Fragment key={detail.label}>
							<Display.GridItem>
								{detail.label}
							</Display.GridItem>
							<Display.GridItem>
								{detail.value}
							</Display.GridItem>
						</Fragment>
					)}
				</For>
			</Display.Grid>
		</Display.Root>
	);
};
